import { STATUS } from 'core/domains/utilities';

import type { Content } from 'core/domains';

export const initialState: Content = {
  'section-cart--edit-combo': {
    data: {
      options: {},
      components: [
        {
          component: 'heading',
          config: {
            featureToggle: true,
            text: 'Você quer editar o combo?',
            level: 'h6',
            textAlign: 'left',
            color: '',
            variation: 'default',
          },
          layout: {
            marginTop: null,
            marginBottom: null,
            alternateColor: null,
            containerWidth: null,
            containerHorizontalAlignment: null,
            containerVerticalAlignment: null,
            componentFluid: null,
            componentFluidMobile: null,
          },
          items: [],
        },
        {
          component: 'text_block',
          config: {
            featureToggle: true,
            text: 'Para alterar a quantidade ou trocar itens do seu combo, você será direcionado para a tela de montagem dos combos.',
            textAlign: 'left',
            variant: 'body-medium-short',
            variation: 'basicText',
          },
          layout: {
            marginTop: null,
            marginBottom: null,
            alternateColor: null,
            containerWidth: null,
            containerHorizontalAlignment: null,
            containerVerticalAlignment: null,
            componentFluid: null,
            componentFluidMobile: null,
          },
          items: [],
        },
        {
          component: 'button',
          config: {
            featureToggle: true,
            trackingEvent: '',
            trackingChildren: '',
            text: 'Ir para montagem de combo',
            action: {
              linkType: 'Any',
            },
            size: null,
            variantStyle: 'primary',
            eventClickButton: null,
            variation: 'solid',
          },
          layout: {
            marginTop: null,
            marginBottom: null,
            alternateColor: null,
            containerWidth: null,
            containerHorizontalAlignment: null,
            containerVerticalAlignment: null,
            componentFluid: null,
            componentFluidMobile: null,
          },
          items: [],
        },
      ],
      meta: {
        id: 'Y-qAXhAAAB8AqASt',
        languages: [],
        locale: 'pt-br',
        slug: null,
        tags: [],
      },
    },
    message: '',
    status: STATUS.SUCCESS,
    updatedAt: 1709224267,
  },
};
